// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xAG9","inner":"Footer_inner__1dskp"};